import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

interface NotificationItemProps {
    notification: {
        id: string | number;
        type: string;
        icon: React.ReactNode;
        bgColor?: string; // Optional - no longer used
        title: string;
        time: string;
        hasThumbnail: boolean;
        thumbnailUrl?: string;
        hasAction: boolean;
        actionText?: string;
        actionRoute?: string;
    };
    isLast: boolean;
}

export const NotificationItem: React.FC<NotificationItemProps> = ({
    notification,
    isLast,
}) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleActionClick = () => {
        if (notification.actionRoute) {
            navigate(notification.actionRoute);
        }
    };

    return (
        <li
            className={`flex items-start gap-4 py-[15px] ${
                !isLast ? 'border-b border-slate-200 dark:border-gray-700' : ''
            }`}
        >
            {/* Icon */}
            <div className="flex-shrink-0 w-11 h-11 rounded-full flex items-center justify-center">
                {notification.icon}
            </div>

            {/* Content */}
            <div className="flex-1 flex flex-col gap-1 min-w-0">
                <p className="font-semibold text-base text-gray-900 dark:text-gray-100 leading-[26px]">
                    {notification.title}
                </p>
                <time className="text-sm text-gray-600 dark:text-gray-400 leading-5">
                    {notification.time}
                </time>
            </div>

            {/* Thumbnail (for events) */}
            {/* {notification.hasThumbnail && (
                <div className="flex-shrink-0 w-32 h-16 bg-gray-300 dark:bg-gray-600 rounded-[15px] overflow-hidden">
                    {notification.thumbnailUrl ? (
                        <img
                            src={notification.thumbnailUrl}
                            alt=""
                            className="w-full h-full object-cover"
                        />
                    ) : (
                        <div className="w-full h-full" aria-hidden="true" />
                    )}
                </div>
            )} */}

            {/* Action Button (for support tickets) */}
            {/* {notification.hasAction && notification.actionText && (
                <button
                    onClick={handleActionClick}
                    className="flex-shrink-0 h-9 px-[12.8px] py-[7.6px] bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-md hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
                >
                    <span className="font-semibold text-sm text-gray-700 dark:text-gray-300 whitespace-nowrap">
                        {t('notifications.actions.viewTicket')}
                    </span>
                </button>
            )} */}
        </li>
    );
};

